
import React from 'react';
import {
    Grid,
    Typography, Card, CardContent, Button, IconButton,
    InputAdornment,
    useFormControl, FormHelperText, Box, Checkbox, FormControlLabel
} from '@mui/material';
import { Redirect, useHistory } from 'react-router-dom'
import { UserRegisterT } from './RegisterScreen';


import Validator from 'jsonschema'


// import { Parser as HtmlToReactParser } from 'html-to-react'
import { UserAgreement } from './UserAgreement';
import { AxiosInstance } from '../../utils/RequestMethods';
import config from '../../constants/config';
import ButtonLoading from '../../components/ButtonLoading';
import { copyObject } from '../../utils';

var schema = {
    "id": "/addressTab",
    "type": "object",
    "properties": {
        "address": { "type": "string", "minLength": 2 },
        "address2": { "type": "string" },
    },
    "required": ["address"]
};


export type IAgreeTabProps = {
    fields: UserRegisterT
    onChangeField(key: string, value: any): void
    nextTab(fields: UserRegisterT): void

}

const AgreeTab: React.FC<IAgreeTabProps> = (props) => {

    const [showPassword, setShowPassword] = React.useState(false)
    const [showRePassword, setShowRePassword] = React.useState(false)

    const validatorRef = React.useRef(new Validator.Validator())
    let history = useHistory()

    React.useEffect(() => {
        validatorRef.current = new Validator.Validator()
    }, []);


    const onChangeField = (key: string, value: any): void => {
        props.onChangeField(key, value)

    }
    const getValue = (key, fields) => {
        return fields[key] && fields[key] != null ? fields[key] : ""
    }


    const checkValidate = React.useCallback((params: UserRegisterT) => {
        if (!params.agree) {
            return false
        }
        return true
    }, [props.fields]);





    const next = async (params: any): Promise<string> => {
        try {

            if (checkValidate(params)) {
                props.nextTab(params)
                return ""
            }
        } catch (error) {
            throw error
        }
    }

    const naviagte = (path: string, email, password): void => {

        history.push({
            pathname: `${path}`,
            params: {
                email: email,
                password: password
            }
        });

    }

    const createUser = async (params): Promise<string> => {

        try {


            if (!checkValidate(params)) {
                throw new Error("Please check and input correct fields!")
            }

            let res = await AxiosInstance.post(`${config.url.users}/signup`, params)
            if (res && res.data) {
                const email = copyObject(props.fields.email)
                const password = copyObject(props.fields.password)

                props.nextTab(props.fields)

                setTimeout(() => {
                    naviagte("login", email, password)
                    // navigation.navigate("LoginScreen", { msg: 'Create account successfully.', email: props.fields.email, password: props.fields.password });
                }, 1000);
                return "Create account."
            }

        } catch (error) {
            throw error
        }
    }

    // const htmlToReactParser = new HtmlToReactParser()
    return (
        <Box>

            {/* <CardContent style={{ justifyContent: "center", display: "flex" }}> */}

            <Grid container spacing={3} mt={2} xs={12}>
                <Grid item xs={12}>

                    <UserAgreement />

                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        label="I agree to the Terms above."
                        color="success"
                        checked={getValue("agree", props.fields) == true ? true : false}
                        onChange={() => {
                            onChangeField('agree', !props.fields.agree)
                        }}
                        control={
                            <Checkbox color="success" />}
                    />
                </Grid>

                <Grid item xs={12} >
                    <ButtonLoading
                        customButton={Button}
                        customButtonProps={{
                            fullWidth: true,
                            variant: "contained",
                            color: "success"
                        }}

                        disabled={!checkValidate(props.fields)}
                        onClickFetching={async (): Promise<string> => {
                            return await createUser(props.fields)
                        }}

                    >
                        <Typography variant="button" color="#fff">Create Account</Typography>
                    </ButtonLoading>
                </Grid>
            </Grid>


            {/* </CardContent> */}
        </Box>
    );
}

export default AgreeTab
export { AgreeTab }
